export default "__VITE_ASSET__301210ff__"